import React, { useState, useEffect } from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import sunburst from 'highcharts/modules/sunburst';
import boost from 'highcharts/modules/boost';
import exporting from 'highcharts/modules/exporting';
import offline from 'highcharts/modules/offline-exporting';

import wrap from './Wrap';

sunburst(Highcharts);
boost(Highcharts);
exporting(Highcharts);
offline(Highcharts);
wrap(Highcharts);

const Chart = ({
  config,
  // в настоящий момент не всегда передается, поэтому задано дефолтное значение.
  setChart = () => {},
  height = '100%',
  unitId,
}) => {
  const [chartOptions, setChartOptions] = useState({
    chart: {
      animation: false,
      style: {
        fontFamily: 'Arial, Helvetica, sans-serif',
      },
    },
    boost: {
      seriesThreshold: 1000,
    },
    tooltip: {
      followTouchMove: true,
      followPointer: true,
    },
    credits: {
      enabled: false,
    },
    navigation: {
      buttonOptions: {
        verticalAlign: 'bottom',
        y: 10,
        align: 'left',
      },
    },
    exporting: {
      enabled: false,
      fallbackToExportServer: false,
    },
    buttons: {
      Fullscreen: {
        verticalAlign: 'bottom',
        align: 'left',
        text: 'full screen',
        onclick() {
          // eslint-disable-next-line react/no-this-in-sfc
          this.fullscreen.toggle();
        },
      },
    },
  });

  useEffect(() => {
    setChartOptions(config);
  }, [config]);

  return (
    <div style={{ height, width: '100%' }} data-id={`chart-wrapper_${unitId}`}>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        constructorType="chart"
        containerProps={{ className: 'chart-wrap' }}
        callback={(chart) => {
          const chartVar = chart;

          if (unitId) {
            chartVar.userOptions.unitId = unitId;
          }

          // при скачивании графика Highcharts создает экземпляр чарта, который попадает в эту колбэк функцию
          // и глобальный массив Highcharts.charts и сетается в дашборды, переписывая ссылку на исходный чарт. Затем этот чарт удаляется.
          // И при попытке клика по fullscreen(иконка сверху/справа) после скачивания у нас уже нет ссылки на чарт.
          // Поэтому здесть добавлена проверка наличия чарта в глобальном Highcharts.charts после тайм-аута,
          // так как к этому моменту чарт уже удален и таким образом ссылка на исходный чарт не переписывается.
          setTimeout(() => {
            if (Highcharts.charts.includes(chartVar)) {
              setChart(chartVar);
            }
          }, 0);
        }}
      />
    </div>
  );
};

export default Chart;
